import React from "react";

const ServiceTerms = () => {
  return (
    <div className="content">
      <p>
        <strong>제 1 장 총칙</strong>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제1조 (약관의 목적)</strong>
      </p>
      <p>
        본 이용약관(이하 '약관')은 주식회사 아이나비시스템즈(이하
        &lsquo;회사&rsquo;)가 운영하는 INAVI Maps 서비스를 이용함에 있어 필요한
        이용조건 및 제반 절차를 정하고 INAVI Maps 서비스를 이용하는 회원과 회사 간의
        권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제2조 (용어의 정의)</strong>
      </p>
      <ol>
        <li>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</li>
      </ol>
      <ul>
        <li>
          &lsquo;INAVI Maps 서비스&rsquo;란, Web과 Mobile 환경에서 지도 정보를
          제공하는 위치 기반 솔루션으로, 신속한 HTTP REST API를 통해 다양한
          기능을 손쉽게 연계하고 확장할 수 있도록 설계된 Open API 플랫폼입니다.
        </li>
        <li>
          &lsquo;사이트&rsquo;란 &lsquo;INAVI Maps 서비스&rsquo;를 제공하는 유무선
          홈페이지({process.env.REACT_APP_SITE_URL})를 말합니다.
        </li>
        <li>
          &lsquo;회사&rsquo;란 &lsquo;INAVI Maps 서비스&rsquo;를 제공하는 주식회사
          아이나비시스템즈를 의미합니다. INAVI Maps 서비스를 제공하는 회사의 일반
          사항은 다음과 같습니다.
        </li>
      </ul>
      <table>
        <tbody>
          <tr>
            <td width="100">
              <p>회사명</p>
            </td>
            <td width="486">
              <p>주식회사 아이나비시스템즈</p>
            </td>
          </tr>
          <tr>
            <td width="100">
              <p>대표자</p>
            </td>
            <td width="486">
              <p>성 득 영</p>
            </td>
          </tr>
          <tr>
            <td width="100">
              <p>주소</p>
            </td>
            <td width="486">
              <p>(13493) 경기도 성남시 분당구 판교역로240, 에이동 8층</p>
              <p>(삼평동, 삼환하이펙스)</p>
            </td>
          </tr>
          <tr>
            <td width="100">
              <p>연락처</p>
            </td>
            <td width="486">
              <p>02-589-9610</p>
            </td>
          </tr>
          <tr>
            <td width="100">
              <p>Fax</p>
            </td>
            <td width="486">
              <p>02-589-9009</p>
            </td>
          </tr>
          <tr>
            <td width="100">
              <p>홈페이지</p>
            </td>
            <td width="486">
              <p>https://www.inavisys.com/</p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul>
        <li>
          &lsquo;회원&rsquo;이란 &lsquo;INAVI Maps 서비스&rsquo; 이용을 위해 본
          &lsquo;약관&rsquo;에 동의하고 &lsquo;약관&rsquo;에 따라 &lsquo;INAVI Maps
          서비스&rsquo;를 이용하는 자를 말하며, 14세 미만의 미성년자는 회원에서
          제외됩니다.
        </li>
        <li>
          &lsquo;회원&rsquo;이란 본 약관에 동의하고, INAVI Maps 서비스 이용을
          신청하여, 회사로부터 INAVI Maps 서비스 이용에 대한 자격을 부여받은 고객을
          말합니다.
          <br /> 가. 개인회원: 개인 신분으로 가입한 회원을 의미합니다.
        </li>
      </ul>
      <p>
        나. 사업자회원: 사업자의 대리인 자격으로 추가로 사업자 정보를 입력,
        가입한 회원을 의미합니다.
      </p>
      <ul>
        <li>
          &lsquo;이용계약&rsquo;이란, INAVI Maps 서비스를 제공받기 위해서 이 약관으로
          회사와 회원 간에 체결하는 계약을 말합니다.
        </li>
        <li>
          &lsquo;이용계약 해지&rsquo;란, 회원이 INAVI Maps 서비스 가입 후 이용계약을
          해약하는 것입니다.
        </li>
      </ul>
      <ol start="2">
        <li>
          본 약관에서 사용하는 용어의 정의는 본 조 제1항에서 정하는 것을
          제외하고는 관계법령 및 INAVI Maps 서비스 안내에서 정하는 바에 의합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제3조 (약관의 효력 및 변경, 약관 외 준칙)</strong>
      </p>
      <ol>
        <li>
          본 약관은 회사의 INAVI Maps 서비스를 이용하려는 회원이 본 약관에
          동의함으로써 효력이 발생합니다.&nbsp;
        </li>
        <li>
          본 약관은 INAVI Maps 서비스 화면에 게시하거나 기타의 방법으로 회원에게
          공시합니다.
        </li>
        <li>
          회사는 필요한 경우 관련 법령에 따라 또는 이에 위배되지 아니하는 범위
          내에서 본 약관을 변경할 수 있습니다. 회사가 본 약관을 변경할 경우,
          회사는 INAVI Maps 서비스 화면 또는 회사의 인터넷 사이트를 통해 변경 사유를
          명시하여 적용일자 15일 전부터 공지합니다. &nbsp;단, 회원의 권리 또는
          의무에 관한 중요한 규정의 변경은 최소 30일 전에 INAVI Maps 서비스 화면에
          게시하여 공지하는 방법으로 고지합니다.
        </li>
        <li>
          변경된 약관에 동의하지 아니하는 회원은 INAVI Maps 서비스 이용이 제한될 수
          있으며, 회원이 약관 동의를 철회할 경우 회원은 INAVI Maps 서비스를 이용할 수
          없습니다. 회원이 회사의 약관 변경 고지 후 INAVI Maps 서비스 동의 거부 및
          탈퇴 등의 의사를 표시하지 않을 경우 회원은 변경된 약관에 동의한 것으로
          봅니다. 이에, 변경된 약관은 약관 말미의 발효일자에 그 효력이 발생되며
          회사는 회원이 약관 변경사항 공지 또는 고지를 확인할 수 없었다는 이유로
          그에 따른 법적 책임을 부담하지 않습니다.
        </li>
        <li>
          본 약관에 명시되지 않은 사항에 대해서는 &lsquo;전기통신사업법&rsquo;,
          &lsquo;개인정보보호법&rsquo;, &lsquo;정보통신망 이용 촉진 및 정보보호
          등에 관한 법률&rsquo;, &lsquo;위치정보의 보호 및 이용 등에 관한
          법률&rsquo;, &lsquo;개인정보보호법&rsquo; 등 관계 법령 등 국내법에
          따르며, 회원은 본 약관 및 운영정책 등의 내용에 변경이 있는지를
          확인하여야 하며, 회사는 회원이 확인하지 않아 발생한 손해에 대해서는
          책임을 부담하지 않습니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 2 장 INAVI Maps 서비스의 이용</strong>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제4조 (INAVI Maps 서비스의 이용)</strong>
      </p>
      <ol>
        <li>
          INAVI Maps 서비스를 이용하고자 하는 회원은 본 약관에 동의하고, 이를
          승낙함으로써 INAVI Maps 서비스 이용계약이 체결됩니다.
        </li>
        <li>
          회사는 제1항에 따른 이용약관이 동의 과정에서 필요한 경우 실명확인 또는
          본인인증 등 절차의 진행을 요구할 수 있습니다.
        </li>
        <li>
          회사는 다음 각 호에 해당하는 경우에는 승낙하지 않거나, 이용계약을
          해지할 수 있습니다.
        </li>
      </ol>
      <p>1) 14세 미만의 아동이 이용신청을 할 경우</p>
      <p>
        2) 본 약관 또는 관계법령 등에 위배되거나 회사가 정한 이용신청 요건을
        충족하지 못하는 등 위법 또는 부적절한 이용신청임이 확인된 경우.
      </p>
      <ol start="4">
        <li>
          회사가 본 조에 따라 이용신청의 승낙을 보류하거나 거절하는 경우, 회사는
          부득이한 사유가 없는 한 관련사항을 신청자에게 통지합니다.
        </li>
        <li>
          회원이 본 약관에 동의하고 INAVI Maps 서비스를 제공받는 경우, 회사에서 정한
          약관 및 운영정책 등을 준수한다는 의사를 표시한 것으로 간주됩니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>
        <strong>제5조 (INAVI Maps 서비스 내용)</strong>
      </p>
      <ol>
        <li>회사가 제공하는 INAVI Maps 서비스 종류와 내용은 아래와 같습니다.</li>
      </ol>
      <table width="599">
        <tbody>
          <tr>
            <td width="104">
              <p>
                <strong>서비스명</strong>
              </p>
            </td>
            <td width="495">
              <p>
                <strong>서비스 내용</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="104">
              <p>INAVI Maps</p>
              <p>서비스</p>
            </td>
            <td width="495">
              <p>
                INAVI Maps가 제공하는 API를 통해 회원이 개발한 WEB 또는 애플리케이션에
                지도 제작, 위치 기반 기술, 내비게이션(도보/PM 포함) 등을 적용할
                수 있도록 지원하며, On-Demand 산업에 특화된 맞춤형 기능 및
                서비스에 활용할 수 있도록 연결하는 역할을 합니다.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ol start="2">
        <li>
          회사는 회원의 INAVI Maps 서비스 이용에 있어 편의를 도모하고 서비스 이용의
          효율을 높이기 위해 다양한 INAVI Maps 서비스를 구성하여 제공할 수 있습니다.
        </li>
        <li>
          제1항에 따른 INAVI Maps 서비스의 이용방법 및 이용상 주의사항 등은 홈페이지를
          통하여 안내하거나, INAVI Maps 서비스 내 공지사항 또는 운영정책 등을 통하여
          공지합니다.
        </li>
        <li>
          회사가 제공하는 INAVI Maps 서비스의 상품(요금제) 종류와 내용은 아래와
          같습니다.
        </li>
      </ol>
      <table width="599">
        <tbody>
          <tr>
            <td width="104">
              <p>
                <strong>상품명</strong>
              </p>
            </td>
            <td width="495">
              <p>
                <strong>상품 내용</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td width="104">
              <p>FREE</p>
            </td>
            <td width="495">
              <p>
                INAVI Maps 이용 이력이 없는 사업자 회원에 한하여
                &lsquo;SMART100&rsquo; 구독 상품을 무료로 1회, 30일 이용 가능한
                체험판 상품입니다.
              </p>
            </td>
          </tr>
          <tr>
            <td width="104">
              <p>SMART100</p>
            </td>
            <td width="495">
              <p>
                월 1,000,000원(VAT 별도)의 후불형 구독 상품으로, 제공된 서비스
                범위 내에서는 추가 요금 없이 이용할 수 있습니다.
              </p>
              <p>
                제공된 호출량 초과 시 &lsquo;START&rsquo; 상품의 요금이 자동
                적용되어 회원 서비스 중단 없이 이용이 가능한 상품입니다.
              </p>
            </td>
          </tr>
          <tr>
            <td width="104">
              <p>START</p>
            </td>
            <td width="495">
              <p>
                월간 API를 호출한 사용량에 따라 후불 청구되는 상품으로, 사용량의
                월별 편차가 있는 경우 또는 단위 API 테스트 시 적합한 상품입니다.
              </p>
            </td>
          </tr>
          <tr>
            <td width="104">
              <p>ENTERPRISE</p>
            </td>
            <td width="495">
              <p>
                대량 사용 할인, 업종에 따른 특화 요금 및 커스터마이징 서비스를
                제공하는 상품입니다.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        <strong>제 6조 (INAVI Maps 서비스 이용요금 및 납입방법)</strong>
      </p>
      <ol>
        <li>
          INAVI Maps 서비스 이용을 통해 회원이 회사에 지급하여야 할 이용료는 웹사이트
          내 요금제 메뉴의 서비스별 요금 내용을 확인해 주시기 바라며, 회사는
          유료 서비스 이용요금을 회사와 계약한 전자지불 업체에서 정한 방법에
          의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.
        </li>
        <li>
          유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제
          이용약관 또는 통신사 등의 과금 정책 및 관계법에 따릅니다.
        </li>
        <li>
          회원의 개인정보 도용 및 결제사기로 인한 환불요청 또는 결제자의
          개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있으며, 무선 서비스
          이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 통신사의 정책에
          따릅니다.
        </li>
        <li>
          INAVI Maps 서비스의 요금은 INAVI Maps 서비스 확장 및 변경에 의해 필요에 따라 인상,
          인하될 수 있습니다. 이 경우 INAVI Maps 서비스 페이지를 통해서 고객에게 사전
          공지됩니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제7조 (결제의 이용)</strong>
      </p>
      <ol>
        <li>
          회원은 회사가 정한 결제방법인 신용카드 결제를 통하여 INAVI Maps 서비스
          이용요금을 결제할 수 있습니다.
        </li>
        <li>
          INAVI Maps 서비스는 1개월 유료 서비스 이용에 따른 요금이 익월 정해진 일시에
          정기 결제가 이루어지며 회원이 해당 INAVI Maps 서비스의 이용을 중단하지
          아니하고 서비스 이용을 지속하는 한 매월 결제가 이루어집니다.
        </li>
        <li>
          FREE, SMART100 상품(요금제)의 경우 사용 한도 초과 시 회원 서비스
          무중단 이용을 목적으로 초과 이용량에 대하여 START 상품의 요금이
          적용되어 이용요금이 결제됩니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제8조 (INAVI Maps 서비스의 이용개시)</strong>
      </p>
      <ol>
        <li>
          회사는 회원이 본 약관에 동의한 시점부터 INAVI Maps 서비스를 개시합니다. 단,
          일부 INAVI Maps 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다.
        </li>
        <li>
          회사의 업무상 또는 기술상의 장애로 인하여 INAVI Maps 서비스를 개시하지
          못하는 경우에는 INAVI Maps 서비스 화면에 공시하거나 회원에게 이를
          통지합니다.
        </li>
        <li>
          APP 추가 시, 회원은 회사에서 요구하는 정보를 정확히 입력해야 합니다.
          입력된 정보가 부정확할 경우, 회사는 서비스 회원의 서비스 이용을 제한할
          수 있습니다.
        </li>
        <li>
          APP 추가 완료되면, 회원은 원하는 상품을 선택하여 이용할 수 있으며,
          콘솔을 통해 서비스 설정이 가능합니다.
        </li>
      </ol>
      <ul>
        <li>
          회원은 APP을 삭제하기 전 데이터를 미리 백업해야 하며, 백업하지 않아
          발생하는 문제에 대해서는 회사가 책임지지 않습니다.
        </li>
        <li>
          회원은 추가한 APP을 회원의 실제 Application과 연동하거나 개발
          목적으로만 사용할 수 있으며, 다른 용도로 활용을 원하는 경우 회사의
          사전 서면 승인을 받아야 합니다.
        </li>
        <li>
          사업자 회원이 등록한 APP은 사업자의 요청에 따라서 권리자 권한을
          회수하거나, 다른 회원에게 이전할 수 있으며 이 과정에서 회사는 회원에게
          사업자 확인 절차(예시: 사업자등록증, 법인인감증명서)를 요청할 수
          있습니다.
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>제9조 (INAVI Maps 서비스의 이용 시간) </strong>
      </p>
      <ol>
        <li>
          INAVI Maps 서비스의 이용은 1일 기준으로 24시간 제공을 원칙으로 합니다. 다만,
          회사는 정기점검 등 업무상, 기술상의 이유로 INAVI Maps 서비스 이용의 전부
          또는 일부를 제한할 수 있으며, 이 경우 회사는 사전에 이를 회원이 등록한
          전자우편 주소를 통하여 INAVI Maps 서비스 내용의 변경사항 또는 종료사항을
          통지 ∙ 공지합니다.
        </li>
        <li>
          회사는 제공하는 INAVI Maps 서비스 중 일부에 대하여 별도의 이용 시간을 정할
          수 있으며, 불특정 다수인을 상대로 통지를 함에 있어서는
          애플리케이션(application) INAVI Maps 서비스 화면 등 기타 회사의 공지사항을
          통하여 회원들에게 통지할 수 있습니다. 이 경우 관련 사항을 사전에
          아이나비 웹사이트 또는 INAVI Maps 서비스 내의 공지사항을 통해 공지합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제10조 (INAVI Maps 서비스 중단 및 변경사항)</strong>
      </p>
      <ol>
        <li>
          회사는 본 약관에서 정한 INAVI Maps 서비스의 내용 및 제공일자를 본 약관에
          명시한 방법으로 회원에게 통지한 후 회원의 동의를 얻어 INAVI Maps 서비스를
          변경, 제공할 수 있습니다. 다만, 회사가 통제할 수 없는 사유로 인한 INAVI Maps
          서비스의 중단(운영자의 고의, 과실이 없는 장애, 시스템다운 등)으로
          인하여 사전 통지가 불가능한 경우에는 그 사유가 종료된 후 즉시
          통지합니다.
        </li>
        <li>
          회사는 본 조의 다음 각 호에 따라 해당사항이 발생하는 경우, 회사는 INAVI Maps
          서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.
        </li>
      </ol>
      <ul>
        <li>회원이 본 약관을 위반하거나 철회하는 경우</li>
        <li>
          정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 INAVI Maps 서비스
          이용에 지장이 있는 경우
        </li>
        <li>
          INAVI Maps 서비스 제공업자와 계약종료, 경영상의 판단 등과 같은 회사의 제반
          사정으로 INAVI Maps 서비스를 유지할 수 없는 경우
        </li>
      </ul>
      <ol start="5">
        <li>
          회사는 무료로 제공되는 INAVI Maps 서비스의 변경, 중단으로 발생하는 문제에
          대해서 회사에 귀책사유가 없는 한 회사는 책임을 지지 않습니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제11조 (INAVI Maps 서비스 이용기간)</strong>
      </p>
      <ol>
        <li>
          회원은 INAVI Maps 서비스를 가입한 날을 기준으로 종료 및 해지 이전까지 INAVI Maps
          서비스를 이용할 수 있습니다. 회원이 INAVI Maps 서비스 이용가능 기간내에 INAVI Maps
          서비스 해지를 신청하더라도 요금납부에 따라 INAVI Maps 서비스 이용기간 동안은
          INAVI Maps 서비스가 제공됩니다.
        </li>
        <li>
          INAVI Maps 서비스 이용기간은 회원이 실제로 INAVI Maps 서비스를 이용하는 것과는
          무관하게, 납부요금에 따른 회원의 INAVI Maps 서비스 이용이 가능한 기간을
          말합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제12조 (이용요금의 환불규정)</strong>
      </p>
      <ol>
        <li>회원이 기 납부한 이용요금은 원칙적으로 환불되지 않습니다.</li>
        <li>
          회원은 회사의 귀책사유로 인해서 INAVI Maps 서비스를 이용하지 못하는 경우
          환불을 요구할 수 있습니다. 단, 이 경우 이용요금을 납입한 날로부터
          1주일 이내에 환불을 요청해야 합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제13조 (계약의 해지) </strong>
      </p>
      <ol>
        <li>
          회원은 회사에 이용계약 해지의사를 통지함으로써 이용계약을 해지할 수
          있습니다. 다만, 회원은 해지의사를 통지하기 전에 현재 진행 중인 모든
          유료서비스의 거래를 완료하거나 철회 또는 취소하여야 합니다. 만일
          결제실패에 따른 미수가 있을 경우에는, 회원은 해당 결제를 완료한 후
          해지의사를 통지하여야 합니다.
        </li>
        <li>
          회사는 제1항에 따른 이용계약 해지로 인해 발생할 수 있는 불이익 등에
          대하여 귀책사유가 없으면 책임을 부담하지 않습니다. 회사가 이용계약에
          기초하여 회원에게 무상으로 지급한 일체의 혜택은 이용계약 해지와 함께
          소멸됩니다.
        </li>
        <li>
          회원의 귀책사유로 인하여 이용계약이 해지됨으로써 발생한 손해는 당해
          회원이 부담하여야 합니다.
        </li>
        <li>
          회사는 회원이 본 약관에 따른 의무를 위반하는 경우 INAVI Maps 서비스 이용을
          제한하거나 이용계약을 해지할 수 있고, 이 경우 발생하는 모든 책임은
          회원이 부담합니다. 회사는 필요한 경우 회원의 위반행위를 관련 정부기관
          또는 사법기관에 통지할 수 있습니다.
        </li>
        <li>
          회사가 본 조항에 따라 INAVI Maps 서비스 이용을 제한하거나 이용계약을
          해지하는 경우, 회사는 본 약관에서 정한 방법으로 사전에 회원에게
          통지합니다. 단, 부득이한 사유로 인하여 사전 통지가 불가능한 경우에는
          그 사유가 종료된 후 즉시 통지합니다.
        </li>
        <li>
          회원은 전항의 통지일로부터 10일 이내에 항변 및 소명을 할 수 있고, 해당
          항변 및 소명이 정당한 경우 회사는 INAVI Maps 서비스 이용 제한 또는 이용계약
          해지를 취소할 수 있습니다. 단, 회원이 기한 내 항변 또는 소명을 하지
          않은 경우, INAVI Maps 서비스 이용 제한 또는 이용계약 해지에 동의한 것으로
          간주합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 3 장 이용계약 당사자의 의무</strong>
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제 14 조 (회사의 의무)</strong>
      </p>
      <ol>
        <li>
          회사는 관련법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지
          않고, 회원들에게 계속적이고 안정적으로 INAVI Maps 서비스를 제공하기 위하여
          최선을 다합니다.
        </li>
        <li>
          회사는 INAVI Maps 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를
          신속하게 처리하여야 하고, 신속한 처리가 곤란한 경우 그 사유와 처리
          일정을 본 약관에서 정한 방법으로 통지합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 15조 (회원의 의무)</strong>
      </p>
      <ol>
        <li>
          회원은 INAVI Maps 서비스를 이용하기 전에 INAVI Maps 서비스의 이용방법 및 조건 등을
          확인하여야 합니다. 이용방법 및 조건 등을 확인하지 않고 INAVI Maps 서비스를
          이용하여 발생한 손실, 손해에 대한 책임은 회원 본인이 부담하여야
          합니다.
        </li>
        <li>
          회원은 본 약관 및 회사가 INAVI Maps 서비스와 관련하여 통지 또는 고지하는
          내용과 관련법령 등을 준수하여야 하며, 본 약관 및 통지 또는 고지
          내용이나 관련법령을 위반하거나 이행하지 아니하여 발생하는 손실, 손해에
          대한 책임은 회원 본인이 부담하여야 합니다. 회사는 필요한 경우 회원의
          관련법령 등의 위반사실을 정부기관 또는 사법기관에 통지할 수 있습니다.
        </li>
        <li>
          INAVI Maps 서비스와 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생한
          책임과 불이익은 회원이 부담하여야 합니다.
        </li>
        <li>
          회원은 회사가 INAVI Maps 서비스를 안전하게 제공할 수 있도록 협조하여야 하며,
          회사가 회원의 본 약관 위반 등 부적절한 행위를 발견하여 회원에게 해당
          행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야
          합니다.
        </li>
        <li>
          회원은 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며,
          분쟁해결에 대한 회원의 불성실로 인하여 INAVI Maps 서비스 제공자 또는 회사에
          손해가 발생한 경우 회원은 이에 대한 책임을 부담하여야 합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 16 조 (회원의 정보보호)</strong>
      </p>
      <ol>
        <li>
          회사는 회원이 회사에 제공하는 개인정보, 이용정보, 위치정보 등(이하
          &ldquo;개인정보 등&rdquo;이라 함)을 보호하기 위하여 관련법령과 회사가
          정하는 &lsquo;개인정보처리방침&rsquo;에 따라 시스템을 갖추고
          보호정책을 시행합니다.
        </li>
        <li>
          회사는 회원의 개인정보 등을 관련법령상 필요한 경우 등을 제외하고 INAVI Maps
          서비스를 제공하기 위한 목적 이외의 용도로 사용하거나 회원의 동의 없이
          제3자에게 제공하지 않습니다. 다만, 회사는 필요한 경우 회원의 동의를
          받거나 통지를 한 후 개인정보 등의 취급 및 관리업무 일부 또는 전부를
          회사가 선정한 3자에게 제공 및 위탁할 수 있습니다.&nbsp;
        </li>
        <li>
          회사는 &lsquo;개인정보 보호법 제34조에 따라 회원의 개인정보가
          유출되었음을 알게 되었을 때에는 유출된 개인정보 항목, 유출 시점과
          경위, 피해를 최소화할 수 있는 방법 등에 관한 정보, 회사의 대응조치 및
          피해구제절차, 피해발생시 신고 등을 접수할 수 있는 담당부서 및 연락처를
          지체 없이 회원에게 서면 등의 방법 또는 본 약관에서 정한 방법으로
          공지합니다.
        </li>
        <li>
          회원이 이용계약을 해지하는 경우, 회사는 관련법령 및 개인정보처리방침에
          따라 회원의 개인정보 등을 보유하는 경우를 제외하고 해지 즉시 회원의
          모든 정보를 삭제합니다.
        </li>
        <li>
          회원 및 회사는 개인정보 등과 관련한 분쟁이 발생한 경우 상호 원만히
          해결하도록 노력하며, 원만한 해결이 어려울 경우 관계법령에 따라
          &lsquo;개인정보 분쟁조정위원회&rsquo;를 통해 해결합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 4 장 기타</strong>
      </p>
      <p>
        <strong>&nbsp;</strong>
      </p>
      <p>
        <strong>제 17조 (회원에 대한 통지)</strong>
      </p>
      <ol>
        <li>
          회원에 대한 통지를 하는 경우 회사는 INAVI Maps 서비스 화면에 게재합니다.
        </li>
        <li>
          회사는 회원의 일부 및 전체에 대한 통지 및 불특정 다수 회원에 대한
          통지의 경우 INAVI Maps 서비스 게시판, 사이트 게시 등의 방법을 활용함으로써
          제1항의 통지에 갈음할 수 있습니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제18조 (비밀유지)</strong>
      </p>
      <p>
        회원과 회사는 이용계약으로 인해 알게 된 상대방의 영업비밀을 사전
        서면동의 없이 제3자에게 누설할 수 없습니다.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제 19조 (권리의 귀속)</strong>
      </p>
      <ol>
        <li>
          회사가 제공하는 INAVI Maps 서비스, 그에 필요한 소프트웨어, 이미지, 마크,
          로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지식재산권 및 기타
          권리는 관련법령에 기하여 회사가 보유하고 있거나 회사에게 소유권 또는
          사용권이 있습니다. 단, 회원의 데이터 및 제휴계약에 따라 제공된 저작물
          등은 제외합니다.
        </li>
        <li>
          회원은 회사가 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각
          재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 추출, 배포, 제작,
          양도, 재라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없으며,
          제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.
        </li>
        <li>
          회사는 INAVI Maps 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라
          INAVI Maps 서비스 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도,
          판매, 담보제공 등의 처분행위를 할 수 없습니다. 회원은 본 이용약관으로
          인하여 INAVI Maps 서비스를 소유하거나 INAVI Maps 서비스에 관한 저작권을 보유하게
          되는 것이 아니라, 회사로부터 INAVI Maps 서비스의 이용을 허락받게 되는바,
          INAVI Maps 서비스는 정보취득 또는 개인용도로만 제공되는 형태로 회원이 이용할
          수 있습니다.
        </li>
        <li>
          회사는 회원이 본 약관에 명시된 INAVI Maps 서비스 내에 게시한 게시물이 타인의
          저작권, 기타 권리를 침해하더라도 회사의 귀책사유가 없는 한 이에 대한
          민∙형사상의 책임을 부담하지 않습니다. 만일 회원이 타인의 저작권, 기타
          이와 관련된 권리를 침해하였음을 이유로 회사는 특별한 귀책사유 없이
          타인으로부터 손해배상청구 등 이의제기를 받은 경우에 회원은 회사의
          면책을 위하여 노력하여야 하며, 회원은 그로 인해 발생한 회사의 모든
          손해를 부담하여야 합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 20조 (INAVI Maps 서비스 이용 제한 등)</strong>
      </p>
      <p>
        회사는 회원이 본 이용약관 제15조(회원의 의무) 또는 제19조(권리의 귀속)을
        위반하는 경우 INAVI Maps 서비스 이용을 일부 또는 전부 제한할 수 있습니다.
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>제 21조 (면책사항)</strong>
      </p>
      <ol>
        <li>
          회사는 전시, 사변 등 국가비상사태, 천재지변, 기간통신사업자의 INAVI Maps
          서비스 제공 중단, 한전으로부터의 전력공급 중단, 해커의 침입, 컴퓨터
          바이러스 기타 이와 유사한 사정으로 인한 회사 시스템의 작동불능 기타
          회사의 귀책사유 없이 회사가 INAVI Maps 서비스를 제공할 수 없는 경우 회사는
          그로 인한 책임을 면합니다.
        </li>
        <li>
          회사는 통신사 서버 또는 통신 중개업체의 과실로 인한 INAVI Maps 서비스
          불완전으로 발생한 피해는 책임지지 않습니다.
        </li>
        <li>
          회원은 본 약관에 따라 회원의 의무사항을 위반하거나, 타인 명의를
          도용하는 등 회원의 귀책사유로 인하여 INAVI Maps 서비스 제공, 중단, 이용의
          장애가 발생한 경우, 또는 제3자에게 피해가 발생한 경우 회사는 그로 인한
          책임을 부담하지 않습니다.
        </li>
        <li>
          회사는 회원 상호간 또는 회원과 제3자 상호간에 INAVI Maps 서비스를 매개로
          발생한 분쟁에 대해서는 개입하지 않습니다.
        </li>
        <li>
          회사는 회사가 제공하는 INAVI Maps 서비스 사이트와 다른 Website가 각종
          링크(예: 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨) 등의
          방식으로 연결된 경우, 회사는 회원과 당해 Website가 독자적으로 행하는
          일체의 거래에 대해서 어떠한 책임도 지지 않습니다.
        </li>
        <li>
          회사는 회원이 회사의 INAVI Maps 서비스로부터 기대하는 이익을 얻지 못하거나
          제공된 정보에 대한 이용으로 발생하는 손해 등에 대해서는 책임이
          없습니다.
        </li>
        <li>
          회사에서 제공하는 INAVI Maps 서비스 및 INAVI Maps 서비스를 이용하여 얻은 정보에
          대한 오차범위, 이용자 개인의 기대이익, INAVI Maps 서비스 유용성 등의
          최종판단은 회원 자신이 하여야 하고, 그에 따른 책임은 전적으로 회원
          자신에게 있으며, 회사는 그로 인하여 발생하는 손해에 대해서 책임이
          면제됩니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 22조 (분쟁의 해결)</strong>
      </p>
      <ol>
        <li>
          INAVI Maps 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생하는 경우,
          회사와 회원은 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을
          하여야 합니다.
        </li>
        <li>
          제 1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는
          개인정보보호법 제43조(조정의 신청 등)의 규정에 의하여 방송통신위원회
          또는 개인정보분쟁조정위원회에 분쟁조정을 신청할 수 있습니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>제 23조 (준거법 및 관할법원)</strong>
      </p>
      <ol>
        <li>
          본 약관에서 정하지 않은 사항과 이 약관의 해석에 관하여는 대한민국 법령
          및 상관례가 적용됩니다.
        </li>
        <li>
          전조의 규정에도 불구하고 INAVI Maps 서비스와 관련하여 회사와 회원 사이에
          분쟁이 발생하여 소송이 제기되는 경우에는 서울중앙지방법원 또는
          민사소송법상의 관할법원을 제1심 관할법원으로 합니다.
        </li>
      </ol>
      <p>&nbsp;</p>
      <p>
        <strong>[</strong>
        <strong>부칙]</strong>
      </p>
      <p>본 약관은 2025년 02월 27일부터 시행합니다.</p>
    </div>
  );
};

export default ServiceTerms;
